import { Helmet } from "react-helmet";
import ArticleCard from "../Components/ArticleCard";
import CourseSection from "../Components/CourseSection";
import FormationCard from "../Components/FormationCard";
import Header from "../Components/Header";
import MyLoader from "../Components/Loader";
import NavigationComp from "../Components/NavigationComp";
import SelectButton from "../Components/SelectButton";
import Forma from "../Pages/image/Formation.jpg"

const GetAllArticleView = (articles, loading) => {
    const token = sessionStorage.getItem('token');

    return (
        <>
            <Helmet>
                <title>Blog</title>
                <meta name="description" content="Blog" />
                <meta name="robots" content="index, follow" />
            </Helmet>
            <Header title="Nos Articles" image={Forma} />
            <main className="main-content-article">
                <div className="dernieres-actualites-section">
                    <h2 className="section-title">Nos dernières actualités</h2>
                    <div className="container">
                        <div className="row g-4">
                            {loading ? (
                                MyLoader
                                    ()
                            ) : (articles.map((actu, index) => (
                                <a className="col-md-4" href={"/blog/" + actu.id}>
                                    <div key={index}>
                                        <div
                                            className="card actualite-card"
                                            style={{ backgroundImage: `url(${"https://backsc.osc-fr1.scalingo.io" + actu.images})` }}
                                        >
                                            <div className="card-overlay">
                                                <h5 className="card-title">{actu.title}</h5>
                                                <p className="card-date">{new Date(actu.date).toLocaleDateString('fr-FR', {
                                                    year: 'numeric',
                                                    month: 'long',
                                                    day: 'numeric'
                                                })}</p>
                                                <p className="card-description">{actu.content}</p>
                                                <a href={"/blog/" + actu.id} className="card-link">
                                                    En savoir plus &gt;
                                                </a>
                                            </div>
                                        </div>
                                    </div></a>
                            )))}

                        </div>
                        {
                            token === '' && (
                                <a href="/createArticle">
                                    <button
                                        className="inscription-button modif_button"
                                        style={{ marginLeft: '10px' }}
                                    >
                                        Créer un Article
                                    </button></a>
                            )}
                    </div>
                </div>
            </main>
        </>
    );
}

export default GetAllArticleView;
